import {ParticipantOrExSpouse} from '@/model/src/values/dv-12';
import {DomainValueReference} from '@/model/types';
import {InvestorAccount} from '@/types/client-info';

export const mapAccountPurchaserMemberContractholderToDomainValue = (
  purchaserMemberContractHolder: InvestorAccount['purchaserMemberContractHolder'] | undefined,
): DomainValueReference | null => {
  if (purchaserMemberContractHolder === 'P') return {$ref: ParticipantOrExSpouse.PARTICIPANT};
  if (purchaserMemberContractHolder === 'C') return {$ref: ParticipantOrExSpouse.EX_SPOUSE};
  return null;
};
